import Reports from './Reports';



export default Reports;
